const AllMetiersCode = "TOUS";

export default AllMetiersCode;
